export default __webpack_public_path__ + "static/media/AppDev.b6cd128a.png";